export interface IwoProvisioningPlugin {
  start(tokens: ProvisioningTokens): void;
}

export interface ProvisioningTokens {
  accountId: string;
  idToken: string;
}
